import React from 'react';

import Header from './header/Header.jsx';
import Modal from '../modal/Modal.jsx';
import Message from '../message/Message.jsx';

export default class Main extends React.Component {

  render() {
    const { children } = this.props;
    return (
      <div className="page" onClick={() => false}>
        <Header/>
        <Message/>
        <Modal/>
        {
          children
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./book/src/commons/components/layout/Main.jsx